.clickable {
  cursor: pointer;
  /* DS: borders carry separation, not shadows. Hover is a restrained background
     tint (150ms) with no elevation or transform. */
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;
}

.clickable:hover {
  background-color: var(--mantine-color-gray-0);
}

.inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.leftGroup {
  display: flex;
  align-items: center;
  gap: 16px;
}
